import { createReducer } from '@reduxjs/toolkit';
import {
  BLUEBITS_LOGIN,
  BLUEBITS_GET_LOCKERS,
  BLUEBITS_GET_LOCKER_SETTINGS,
  BLUEBITS_GET_LOCKER_PARCELS,
  BLUEBITS_GET_LOCKER_NOTIFICATIONS,
  BLUEMYTH_GET_LOCKERS_FOR_PORTAL,
  BLUEMYTH_LINK_LOCKERS,
  BLUEBITS_CLEAR_STATE
} from '../constants';
import { requestFail, requestPending, requestSuccess } from '../../utils/status';

const initialState = {
  status: '',
  loginStatus: '',
  lockersStatus: '',
  lockerSettingsStatus: '',
  lockerParcelsStatus: '',
  lockerNotificationsStatus: '',
  lockersForPortalStatus: '',
  linkLockersStatus: '',
  auth: null,
  lockers: [],
  lockerSettings: null,
  lockerParcels: null,
  lockerNotifications: null,
  lockersForPortal: [],
  linkResult: null,
  error: null
};

export default createReducer(initialState, {
  [BLUEBITS_CLEAR_STATE]: () => initialState,

  [requestSuccess(BLUEBITS_LOGIN)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(BLUEBITS_LOGIN),
    loginStatus: requestSuccess(BLUEBITS_LOGIN),
    auth: payload,
    error: null
  }),
  [requestPending(BLUEBITS_LOGIN)]: (state) => ({
    ...state,
    status: requestPending(BLUEBITS_LOGIN),
    loginStatus: requestPending(BLUEBITS_LOGIN)
  }),
  [requestFail(BLUEBITS_LOGIN)]: (state, { payload }) => ({
    ...state,
    status: requestFail(BLUEBITS_LOGIN),
    loginStatus: requestFail(BLUEBITS_LOGIN),
    error: payload
  }),

  [requestSuccess(BLUEBITS_GET_LOCKERS)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(BLUEBITS_GET_LOCKERS),
    lockersStatus: requestSuccess(BLUEBITS_GET_LOCKERS),
    lockers: payload,
    error: null
  }),
  [requestPending(BLUEBITS_GET_LOCKERS)]: (state) => ({
    ...state,
    status: requestPending(BLUEBITS_GET_LOCKERS),
    lockersStatus: requestPending(BLUEBITS_GET_LOCKERS)
  }),
  [requestFail(BLUEBITS_GET_LOCKERS)]: (state, { payload }) => ({
    ...state,
    status: requestFail(BLUEBITS_GET_LOCKERS),
    lockersStatus: requestFail(BLUEBITS_GET_LOCKERS),
    error: payload
  }),

  [requestSuccess(BLUEBITS_GET_LOCKER_SETTINGS)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(BLUEBITS_GET_LOCKER_SETTINGS),
    lockerSettingsStatus: requestSuccess(BLUEBITS_GET_LOCKER_SETTINGS),
    lockerSettings: payload,
    error: null
  }),
  [requestPending(BLUEBITS_GET_LOCKER_SETTINGS)]: (state) => ({
    ...state,
    status: requestPending(BLUEBITS_GET_LOCKER_SETTINGS),
    lockerSettingsStatus: requestPending(BLUEBITS_GET_LOCKER_SETTINGS)
  }),
  [requestFail(BLUEBITS_GET_LOCKER_SETTINGS)]: (state, { payload }) => ({
    ...state,
    status: requestFail(BLUEBITS_GET_LOCKER_SETTINGS),
    lockerSettingsStatus: requestFail(BLUEBITS_GET_LOCKER_SETTINGS),
    error: payload
  }),

  [requestSuccess(BLUEBITS_GET_LOCKER_PARCELS)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(BLUEBITS_GET_LOCKER_PARCELS),
    lockerParcelsStatus: requestSuccess(BLUEBITS_GET_LOCKER_PARCELS),
    lockerParcels: payload,
    error: null
  }),
  [requestPending(BLUEBITS_GET_LOCKER_PARCELS)]: (state) => ({
    ...state,
    status: requestPending(BLUEBITS_GET_LOCKER_PARCELS),
    lockerParcelsStatus: requestPending(BLUEBITS_GET_LOCKER_PARCELS)
  }),
  [requestFail(BLUEBITS_GET_LOCKER_PARCELS)]: (state, { payload }) => ({
    ...state,
    status: requestFail(BLUEBITS_GET_LOCKER_PARCELS),
    lockerParcelsStatus: requestFail(BLUEBITS_GET_LOCKER_PARCELS),
    error: payload
  }),

  [requestSuccess(BLUEBITS_GET_LOCKER_NOTIFICATIONS)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(BLUEBITS_GET_LOCKER_NOTIFICATIONS),
    lockerNotificationsStatus: requestSuccess(BLUEBITS_GET_LOCKER_NOTIFICATIONS),
    lockerNotifications: payload,
    error: null
  }),
  [requestPending(BLUEBITS_GET_LOCKER_NOTIFICATIONS)]: (state) => ({
    ...state,
    status: requestPending(BLUEBITS_GET_LOCKER_NOTIFICATIONS),
    lockerNotificationsStatus: requestPending(BLUEBITS_GET_LOCKER_NOTIFICATIONS)
  }),
  [requestFail(BLUEBITS_GET_LOCKER_NOTIFICATIONS)]: (state, { payload }) => ({
    ...state,
    status: requestFail(BLUEBITS_GET_LOCKER_NOTIFICATIONS),
    lockerNotificationsStatus: requestFail(BLUEBITS_GET_LOCKER_NOTIFICATIONS),
    error: payload
  }),

  [requestSuccess(BLUEMYTH_GET_LOCKERS_FOR_PORTAL)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(BLUEMYTH_GET_LOCKERS_FOR_PORTAL),
    lockersForPortalStatus: requestSuccess(BLUEMYTH_GET_LOCKERS_FOR_PORTAL),
    lockersForPortal: payload,
    error: null
  }),
  [requestPending(BLUEMYTH_GET_LOCKERS_FOR_PORTAL)]: (state) => ({
    ...state,
    status: requestPending(BLUEMYTH_GET_LOCKERS_FOR_PORTAL),
    lockersForPortalStatus: requestPending(BLUEMYTH_GET_LOCKERS_FOR_PORTAL)
  }),
  [requestFail(BLUEMYTH_GET_LOCKERS_FOR_PORTAL)]: (state, { payload }) => ({
    ...state,
    status: requestFail(BLUEMYTH_GET_LOCKERS_FOR_PORTAL),
    lockersForPortalStatus: requestFail(BLUEMYTH_GET_LOCKERS_FOR_PORTAL),
    error: payload
  }),

  [requestSuccess(BLUEMYTH_LINK_LOCKERS)]: (state, { payload }) => ({
    ...state,
    status: requestSuccess(BLUEMYTH_LINK_LOCKERS),
    linkLockersStatus: requestSuccess(BLUEMYTH_LINK_LOCKERS),
    linkResult: payload,
    error: null
  }),
  [requestPending(BLUEMYTH_LINK_LOCKERS)]: (state) => ({
    ...state,
    status: requestPending(BLUEMYTH_LINK_LOCKERS),
    linkLockersStatus: requestPending(BLUEMYTH_LINK_LOCKERS)
  }),
  [requestFail(BLUEMYTH_LINK_LOCKERS)]: (state, { payload }) => ({
    ...state,
    status: requestFail(BLUEMYTH_LINK_LOCKERS),
    linkLockersStatus: requestFail(BLUEMYTH_LINK_LOCKERS),
    error: payload
  })
});
